<script lang="ts">
  import { Col, Container, Row } from "sveltestrap";
  import BookmarkWishlist from "./BookmarkWishlist.svelte";
  import Card from "../../../Core/Card.svelte";
  import { Wishlist } from "../../../../utils/Constant/Constant";
  import data from "../../../../Data/Ecommerce/Ecommerce.json"
  import WishlistProduct from "./WishlistProduct.svelte";

</script>
<BookmarkWishlist />
<Container fluid>
    <Row>
      <Col sm="12">
        <Card headerTitle={Wishlist} cardHeaderprops="pb-0" cardBodyprops={"whishlist-main"}>
          <div slot="contentbody">
            <Row class="g-sm-4 g-3">
                {#each data.wishlistdata as wishlistItem}
                    <Col xl="2" md="4" sm="6">
                        <div class="prooduct-details-box">
                            <WishlistProduct wishlistItem={wishlistItem}/>
                        </div>
                    </Col>
                {/each}
            </Row>
          </div>
        </Card>
      </Col>
    </Row>
</Container>